export default "__VITE_ASSET__DDaE1duS__"